/**
 * 实名认证
 */
<template>
    <div class="form">
      <div class="e-form">
        
        <div style="margin-bottom: 36px;display: flex;align-items: center;" class="code">
          <h5>实名认证</h5>
          <p class="authentication-type" v-if="!userInfo.realName">未认证</p>
          <p class="authentication-type authentication-types" v-else>已认证</p>
        </div>
        <div class="item">
          <p class="key"><span class="prop">*</span>真实姓名：</p>
          <el-input v-model="ruleForm.name" placeholder="请输入您的真实姓名" v-if="!userInfo.realName"></el-input>
          <p class="val" v-else>{{ruleForm.name}}</p>
        </div>
        <div class="item">
          <p class="key"><span class="prop">*</span>身份证号：</p>
          <el-input v-model="ruleForm.idCard" placeholder="请输入您的身份证号" v-if="!userInfo.idCard"></el-input>
          <p class="val" v-else>{{ruleForm.idCard}}</p>
        </div>
        <div class="item">
          <p style="font-size: 13px; color: #af9999;line-height: 24px;padding: 0 10px;">注：自动认证系统目前仅支持中国大陆居民身份证。港澳台及外籍人士请将账户ID、手机号和有效证件照片发送至：<span style="color: #ff821c;">education@vastdata.com.cn</span>，我们将在七个工作日内完成人工审核。有效证件包括：护照、外国人居留证、港澳同胞回乡证、港澳居民来往内地通行证、台湾居民来往大陆通行证等。</p>
        </div>
        <div class="but" v-if="!userInfo.idCard">
          <el-button  size="medium" :loading="loading" type="warning" @click="submitForm" style="background-color: #ff821c">提交</el-button>
        </div>
      </div>
    </div>
</template>

<script>
import { userInfo,certificate } from '../../api/userMG'
export default {
  data() {
    return {
      type:1,
      ruleForm: {
        idCard: '',
        name:''
      },
      loading:false
    }
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    }
  },
  /**
   * 创建完毕
   */
  created() {
    // this.getUserInfo();
    console.log("实名认证",this.userInfo)
    this.ruleForm.name = this.userInfo.realName;
    this.ruleForm.idCard = this.userInfo.idCard;
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    onButton(e){
      this.type = e
    },
    async getUserInfo(){
      await userInfo().then(res => {
        console.log('用户信息',res);
        this.userInfo = res.data;
        this.ruleForm.name = this.userInfo.realName;
        this.ruleForm.idCard = this.userInfo.idCard;
      })
      .catch(err => {
        // this.$message.error('请求失败，请稍后再试！')
      })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if(!this.ruleForm.name){
        this.$message({
          message: '请输入真实姓名',
          type: 'warning',
          offset:100
        });
        return
      }
      if(!this.ruleForm.idCard){
        this.$message({
          message: '请输入身份证号',
          type: 'warning',
          offset:100
        });
        return
      }
      this.loading = true
      certificate(this.ruleForm).then(res => {
        this.loading = false
        console.log("提交信息",res.code)
        if(res.code == 0){
          this.$message({
          message: '保存成功！',
          type: 'success',
          offset:100
        });
          this.$emit('getUserInfo');
        }
      })
      .catch(err => {
        this.loading = false
      })
    },
   
  }
}
</script>

<style scoped>
  .form{
    margin:60px auto 0;
    width: 55%;
  }
  h5{
    border-left: 3px solid #ff821c;
    padding-left: 8px;
    border-radius: 2px;
    margin: 0;
  }
  .authentication-type{
    padding: 2px 6px;
    border-radius: 3px;
    background: #e6e6e6;
    font-size: 11px;
    color: #686868;
    margin-left: 10px;
  }
  .authentication-types{
    background: #f68848;
    color: #fff;
  }
  .item{
    margin-bottom: 20px;
  }
  .code{
    display: flex;
    align-items: center;
  }
  .code .el-button--warning{
    padding:12px 28px;
  }
  .code /deep/ .el-input__inner{
    border-right: 0;
    
  }
  .el-button--small{
    padding: 6px 18px;
  }
  .e-form .key{
    font-size: 12px;
    font-weight: 600;
    color: #666;
    margin-bottom: 6px;
  }
  .e-form .el-input{
    font-size: 12px;
  }
  .e-form .val{
    height: 40px;
    background: #f7f9fb;
    font-size: 12px;
    color: #424242;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 4px;
    margin-top: 10px;
  }
  .e-form .prop{
    color: #ff821c;
    margin-right: 2px;
  }
  .e-form .el-button--medium{
    padding: 14px 0px;
    width: 48%;
  }
  .but{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;
  }
</style>

 
 


// WEBPACK FOOTER //
// src/components/data/certification.vue